import { isUUID } from "@common/helpers/uuid";
import { Task } from "@common/types/task";

export const getConnectionMetadata = (task: Task) => {
    const connectionId = task.metadata?.connectionId ?? null;
    return {
        connectionId,
        isIntegrationConnectionId: connectionId ? isUUID(connectionId) : false,
    };
};
